import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cl-check-circle",
  "use": "icon-cl-check-circle-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-cl-check-circle\"><circle cx=\"16\" cy=\"16\" r=\"16\" /><path d=\"M8 8h16v16H8z\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M22.632 10.196c.41.322.49.924.177 1.346l-7.467 10.08a.919.919 0 0 1-1.402.097l-4.667-4.8a.98.98 0 0 1 0-1.358.915.915 0 0 1 1.32 0l3.912 4.023 6.82-9.206a.916.916 0 0 1 1.307-.182Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol